import { render, staticRenderFns } from "./base-skeleton-body.vue?vue&type=template&id=9dabb96c&scoped=true&"
import script from "./base-skeleton-body.vue?vue&type=script&lang=js&"
export * from "./base-skeleton-body.vue?vue&type=script&lang=js&"
import style0 from "./base-skeleton-body.vue?vue&type=style&index=0&id=9dabb96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dabb96c",
  null
  
)

export default component.exports